import React, { Suspense } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import FallbackSpinner from "./@core/components/spinner";
import BlankLayout from "./@core/layouts/BlankLayout";
import BlankLayoutWithAppBar from "./@core/layouts/components/BlankLayoutWithAppBar";

const Page401 = React.lazy(() => import("./pages/401"));
const Page404 = React.lazy(() => import("./pages/404"));
const VayvandanaPassPage = React.lazy(() =>
  import("./pages/cards/vayvandanaPass")
);
const TermsConditionLandingPage = React.lazy(() =>
  import("./pages/Public-Links/terms")
);
const PrivacyPolicyLandingPage = React.lazy(() =>
  import("./pages/Public-Links/privacy")
);
const AboutPage = React.lazy(() => import("./pages/Public-Links/about"));
const StatusPage = React.lazy(() => import("./pages/payment/status"));
const PaymentResultPage = React.lazy(() => import("./pages/payment/result"));

function App() {
  return (
    <Suspense fallback={<FallbackSpinner />}>
      <Routes>
        <Route
          element={
            <BlankLayout>
              <Outlet />
            </BlankLayout>
          }
        >
          <Route path="/401" element={<Page401 />} />
          <Route path="/404" element={<Page404 />} />
        </Route>

        <Route
          element={
            <BlankLayoutWithAppBar>
              <Outlet />
            </BlankLayoutWithAppBar>
          }
        >
          <Route path="/" element={<VayvandanaPassPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsConditionLandingPage />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicyLandingPage />}
          />
          <Route path="/about" element={<AboutPage />} />
        </Route>

        <Route path="/payment/status" element={<StatusPage />} />
        <Route path="/payment-result" element={<PaymentResultPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
